module.exports = __webpack_public_path__ + "static/media/wommenInTechScreen.124240ca.jpg";